<template>
  <RecordsCard
    :title="$t('recordsCard.warmestMonths.title')"
    :subtitle="$t('recordsCard.warmestMonths.subtitle')"
    :footer="warmestMonthsFooter"
    :data="warmestMonths"
    :options="{
      date: {
        year: 'numeric',
        month: 'short',
      },
      unit: '&deg;F',
    }"
  />
</template>
<script setup lang="ts">
import RecordsCard from '~/components/RecordsCard.vue'
const {  t } = useI18n()
const props = defineProps({
      data: {
        required: true,
        type: Object,
      },
      summary: {
        required: false,
        type: Object,
        default: null
      },
      selectedMonth: {
        required: false,
        type: Number,
        default: null
      }
    })

const warmestMonths = computed(() => {
  return props.data
      .select({ date: "title", maxTemp: "value" })
      .objects();
});

const warmestMonthsFooter = computed(() => {
  if (props.selectedMonth !== null) return ''
  let string = "";
  if (Math.round(props.summary.meanDaysAbove100F) > 0) {
    string += t('recordsCard.warmestMonths.footer',{ days: Math.round(props.summary.meanDaysAbove100F) });
  }

  return string;
});



</script>
<script lang="ts">
export default {
  name: 'WarmestMonthsCard'
}
</script>